import { homeDataApi } from '@/api/index'

const homeData = {
  state: {
    topNav: [], // 顶部导航数据
    sliderList: [], // 轮播图数据
    contact: {}, // 基本信息数据
    link: [], // 友情链接数据
    advert: [], // 广告数据
    bottomNav: {}, // 底部导航数据
    notice: [], // 公告数据
    // 可以根据需要添加其他共享数据
  },
  mutations: {
    SET_TOP_NAV: (state, list) => {
      state.topNav = list
    },
    SET_SLIDER_LIST: (state, list) => {
      state.sliderList = list
    },
    SET_CONTACT: (state, list) => {
      state.contact = list
    },
    SET_LINK: (state, list) => {
      state.link = list
    },
    SET_ADVERT: (state, list) => {
      state.advert = list
    },
    SET_BOTTOM_NAV: (state, list) => {
      state.bottomNav = list
    },
    SET_NOTICE: (state, list) => {
      state.notice = list
    }
  },
  actions: {
    // 获取首页数据
    getHomeData({ commit }) {
      return new Promise((resolve, reject) => {
        homeDataApi().then(res => {
          const { slider, top_nav, contact, link, advert, bottom_nav, notice } = res.data
          commit('SET_SLIDER_LIST', slider || [])
          commit('SET_TOP_NAV', top_nav || [])
          commit('SET_CONTACT', contact || {})
          commit('SET_LINK', link || [])
          commit('SET_ADVERT', advert || [])
          commit('SET_BOTTOM_NAV', bottom_nav || {})
          commit('SET_NOTICE', notice || [])
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default homeData
